import { Component, OnInit } from '@angular/core';
import { InstrumentosService } from '../services/instrumentos.service';
import * as moment from 'moment';
declare var $: any;
import { DecimalPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {


  precioActual: number;
  precioMayor: number;
  precioMenor: number;
  precioCierre: number;
  variacion: number;
  razonSocial: String;

  indicesIntraday: any;

  ultimasTransacciones: any = [];

  //ratios

  presBursatil: any;
  utilidadPrecio: any;
  precioUtilidad: any;
  libroAjustado: any;
  bolsaLibroValue: any;
  valorLibroAjustado: any;


  presBursatilIPSA: any;
  utilidadPrecioIPSA: any;
  precioUtilidadIPSA: any;
  libroAjustadoIPSA: any;
  bolsaLibroValueIPSA: any;
  valorLibroAjustadoIPSA: any;

  roe: any;
  ventasActivos: any;
  roeIPSA: any;
  ventasActivosIPSA: any;


  precioHoy: any;
  precioAyer: any;
  precioMes: any;
  precioAno: any;

  mesActual: any;
  mesAnterior: any;
  anoActual: any;
  anoAnterior: any;
  ano7Dias: any;
  dias30: any;
  semanas52: any;

  preMax52Semanas: any;
  preMin52Semanas: any;

  preMax52SemanasIPSA: any;
  preMin52SemanasIPSA: any;

  ultimaActualizacionFecha: any;

  public activeLang = 'es';
  public lang;

  constructor(
    private instrumentosService: InstrumentosService,
    private translate: TranslateService,
    private route: ActivatedRoute
  ) {
    this.precioHoy = {};
    this.precioAyer = {};
    this.precioMes = {};
    this.precioAno = {};

    this.lang = this.route.snapshot.paramMap.get("lang") ? this.route.snapshot.paramMap.get("lang") : '';

    if (this.lang == "es" || this.lang == "en")
      this.activeLang = this.lang;

    this.translate.setDefaultLang(this.activeLang);

  }

  ngOnInit(): void {

    this.ultimaActualizacionFecha = new Date();


    this.instrumentosService.getResumenInstrumento().subscribe(res => {

      let resumenInstrumentoArray = [];
      resumenInstrumentoArray = res['listaResult'];

      this.precioCierre = resumenInstrumentoArray[0]['PRECIO_CIERRE'];
      this.variacion = resumenInstrumentoArray[0]['VAR'];
      this.razonSocial = resumenInstrumentoArray[0]['RAZON_SOCIAL'];

    })

    setInterval(() => {

      this.instrumentosService.getResumenInstrumento().subscribe(res => {
        let resumenInstrumentoArray = [];
        resumenInstrumentoArray = res['listaResult'];

        this.precioCierre = resumenInstrumentoArray[0]['PRECIO_CIERRE'];
        this.variacion = resumenInstrumentoArray[0]['VAR'];
        this.razonSocial = resumenInstrumentoArray[0]['RAZON_SOCIAL'];

      })
    }, 1000);

    this.instrumentosService.getUltimasTransacciones().subscribe(res => {
      this.ultimasTransacciones = res['listaResult'];
    })

    this.instrumentosService.getRentabilidad().subscribe(res => {
      let rentabilidad = res['listaResult'];

      this.ano7Dias = rentabilidad[0]['RENT_7DIAS'];
      this.dias30 = rentabilidad[0]['RENT_30DIAS'];;
      this.semanas52 = rentabilidad[0]['RENT_52SEM'];;

      this.preMax52Semanas = rentabilidad[0]['PRE_MAY_52SEM'];;
      this.preMin52Semanas = rentabilidad[0]['PRE_MEN_52SEM'];;
    })

    this.instrumentosService.getRentabilidad().subscribe(res => {
      let rentabilidad = res['listaResult'];

      this.ano7Dias = rentabilidad[0]['RENT_7DIAS'];
      this.dias30 = rentabilidad[0]['RENT_30DIAS'];;
      this.semanas52 = rentabilidad[0]['RENT_52SEM'];;

      this.preMax52Semanas = rentabilidad[0]['PRE_MAY_52SEM'];;
      this.preMin52Semanas = rentabilidad[0]['PRE_MEN_52SEM'];;
    })

    this.instrumentosService.getRentabilidadIPSA().subscribe(res => {
      let rentabilidad = res['listaResult'];

      this.preMax52SemanasIPSA = rentabilidad[0]['PRE_MAY_52SEM'];;
      this.preMin52SemanasIPSA = rentabilidad[0]['PRE_MEN_52SEM'];;
    })

    this.instrumentosService.getPresencia().subscribe(res => {
      let presencia = res['listaResult'];
      this.presBursatil = presencia[0]['PRESEN_AJU'];

    })

    this.instrumentosService.getPresenciaIPSA().subscribe(res => {
      let presencia = res['listaResult'];
      this.presBursatilIPSA = presencia[0]['PRESEN_AJU'];

    })

    this.instrumentosService.getRatio(24).subscribe(res => {
      console.log(res);
      let ratio = res['listaResult'];
      this.roe = ratio[0]['VALOR_RATIO'];
    })

    this.instrumentosService.getRatioIPSA(24).subscribe(res => {
      console.log(res);
      let ratio = res['listaResult'];
      this.roeIPSA = ratio[0]['VALOR_RATIO'];
    })

    this.instrumentosService.getRatio(25).subscribe(res => {
      console.log(res);
      let ratio = res['listaResult'];
      this.ventasActivos = ratio[0]['VALOR_RATIO'];
    })

    this.instrumentosService.getRatioIPSA(25).subscribe(res => {
      console.log(res);
      let ratio = res['listaResult'];
      this.ventasActivosIPSA = ratio[0]['VALOR_RATIO'];
    })

    

    this.instrumentosService.getResumenPrecios().subscribe(res => {
      let resumenPrecioArray = [];
      resumenPrecioArray = res['listaResult'];

      let precioHoy = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Hoy';
      });

      let precioAyer = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Ayer';
      });

      let precioMes = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Mes';
      });

      let precioAno = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Año';
      });

      let precioUtilidad = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Precio_Utilidad';
      });

      let utilidadPrecio = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Utilidad_Precio';
      });

      let bolsaLibroValue = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Bolsa_Libro_Value';
      });

      let valorLibroAjustado = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Valor_Libro_Ajustado';
      });

      let mesActual = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Mes_Actual';
      });

      let mesAnterior = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Mes_Anterior';
      });

      let anoActual = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Año_Actual';
      });

      let anoAnterior = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Año_Anterior';
      });

      this.mesActual = mesActual[0]['valor'];
      this.mesAnterior = mesAnterior[0]['valor'];
      this.anoActual = anoActual[0]['valor'];
      this.anoAnterior = anoAnterior[0]['valor'];
      this.precioMayor = precioHoy[0]['pre_may'] == undefined ? 0 : precioHoy[0]['pre_may'];
      this.precioMenor = precioHoy[0]['pre_men'] == undefined ? 0 : precioHoy[0]['pre_men'];

      this.precioUtilidad = precioUtilidad[0]['valor'];
      this.utilidadPrecio = utilidadPrecio[0]['valor'];
      this.bolsaLibroValue = bolsaLibroValue[0]['valor'];
      this.valorLibroAjustado = valorLibroAjustado[0]['valor'];

      this.precioHoy = precioHoy[0];
      this.precioHoy.monto = isNaN(Math.round(this.precioHoy.monto / 1000)) ? 0 : Math.round(this.precioHoy.monto / 1000);

      this.precioAyer = precioAyer[0];
      this.precioAyer.monto = isNaN(Math.round(this.precioAyer.monto / 1000)) ? 0 : Math.round(this.precioAyer.monto / 1000);
      this.precioMes = precioMes[0];
      this.precioMes.monto = isNaN(Math.round(this.precioMes.monto / 1000)) ? 0 : Math.round(this.precioMes.monto / 1000);
      this.precioAno = precioAno[0];
      this.precioAno.monto = isNaN(Math.round(this.precioAno.monto / 1000)) ? 0 : Math.round(this.precioAno.monto / 1000);

    })

    this.instrumentosService.getResumenPreciosIPSA().subscribe(res => {
      let resumenPrecioArray = [];
      resumenPrecioArray = res['listaResult'];

      let precioUtilidad = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Precio_Utilidad';
      });

      let utilidadPrecio = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Utilidad_Precio';
      });

      let bolsaLibroValue = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Bolsa_Libro_Value';
      });

      let valorLibroAjustado = resumenPrecioArray.filter(resumenIntrumento => {
        return resumenIntrumento['descripcion'] == 'Valor_Libro_Ajustado';
      });

      this.precioUtilidadIPSA = precioUtilidad[0]['valor']; //*
      this.utilidadPrecioIPSA = utilidadPrecio[0]['valor']; //*
      this.bolsaLibroValueIPSA = bolsaLibroValue[0]['valor']; //*
      this.valorLibroAjustadoIPSA = valorLibroAjustado[0]['valor']; //*



    })

    // this.instrumentosService.getIndiceIntraday().subscribe(resIndiceIntraday => {

    //   let indicesIntradayArray = [];
    //   indicesIntradayArray = resIndiceIntraday['listaResult'];

    //   let sizeArray = indicesIntradayArray.length;

    //   for (let index = 0; index < 5; index++) {
    //     let position = (sizeArray - 1) - index;
    //     let transaction = indicesIntradayArray[position];
    //     this.ultimasTransacciones.push(transaction);
    //   }

    // })

    this.instrumentosService.getMetaHistory().subscribe(resMetaHistory => {

      let indicesIntradayArray = [];
      indicesIntradayArray = resMetaHistory['listaResult'];

      let data = [];
      let categories = [];

      let sizeArray: number = indicesIntradayArray.length;

      indicesIntradayArray.forEach(element => {

        data.push(element['CLOSE']);
        categories.push(moment(element['DATE']).format("DD/MM/YYYY"));

      });

      let chart = $("#chart-line-prices").kendoChart({
        title: {
          // text: "Gráfico de Precios Diarios"
        },
        theme: "material",
        seriesColors: ["#0069b4", "#0069b4", "#0069b4", "#0069b4", "#0069b4", "#0069b4", "#0069b4", "#0069b4", "#0069b4", "#0069b4"],
        legend: {
          position: "bottom",
          visible: false,
        },
        chartArea: {
          background: ""
        },
        seriesDefaults: {
          type: "line",
          style: "smooth"
        },
        series: [
          {
            name: "Diarios",
            data: data,
          }
        ],
        valueAxis: {
          labels: {
            format: "{0}"
          },
          line: {
            visible: false
          },
          axisCrossingValue: -20
        },
        categoryAxis: {
          categories: categories,
          majorGridLines: {
            visible: false
          },
          labels: {
            rotation: "auto", 
            step:5
          },
          min: sizeArray - 10,
          max: sizeArray
        },
        tooltip: {
          visible: true,
          format: "10{0},00",
          template: "#= category #: #= value #"
        },
        pannable: {
          lock: "y"
        },
        zoomable: {
          mousewheel: {
            lock: "y"
          },
          selection: {
            lock: "y"
          }
        }
      });

      $(document).ready(chart);
      $(document).bind("kendo:skinChange", chart);

    });

  }

  transform(value: any) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");;
  }

  public cambiarLenguaje(lang) {
    this.activeLang = lang;
    this.translate.use(lang);
  }
}
